import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PromotionService, CorpInfo } from '../../../services/index';
import _ from 'lodash';
import { Util } from '../../../utils/util';

@Component({
  selector: 'company-selector',
  templateUrl: 'company-selector.html'
})
export class CompanySelectorComponent {
  @Input() selectedCorp: CorpInfo;
  @Input() disabled: boolean = false;
  @Output() onCorpSelect: EventEmitter<CorpInfo> = new EventEmitter();

  companyList: Array<CorpInfo> = [];
  company: CorpInfo;
  isCorpListOpen:boolean = false;
  filteredCompanyList: Array<CorpInfo> = [];
  focusedCorpIndex: number;

  @ViewChild("companyList") companyListElRef: ElementRef;

  companyControl: FormControl  = new FormControl();

  constructor(private promotionService: PromotionService) {}

  ngOnInit() {
    this.companyList = this.promotionService.companyList;

    if(_.isEmpty(this.companyList)) {
      this.promotionService.companyListEe.subscribe(
        companies => {
          this.companyList = companies;
          this.checkInputCompany();
        }
      )
    } else {
      this.checkInputCompany();
    }
  }

  checkInputCompany() {
    if(this.selectedCorp != null) {
      this.companyControl.setValue(this.selectedCorp.corpNm);
    }
  }

  setFilteredCompanyList(event) {
    if (!event) return;
    
    let keyword = event.target.value;
    if (!keyword) {
      if (this.selectedCorp) this.selectedCorp = null;
      this.onCorpSelect.emit(null);
      this.isCorpListOpen = false;
      return;
    }

    if(keyword.length > 0 && this.companyList != null) {
      keyword = _.toUpper(keyword.trim()).replace(/\s/g, '');
		  let companyList = _.clone(this.companyList);
      
      this.filteredCompanyList = companyList.filter(item => {
        let valuesStr = Util.getString(item);
        const filter = keyword.toLocaleLowerCase();
        return valuesStr.indexOf(filter) >= 0;
      });

      this.isCorpListOpen = true;
      this.focusedCorpIndex =  0;    
    } else {
      this.isCorpListOpen = false;
    }
  }

  handleKeyDown(event) {
    if (event.keyCode !== 13 && event.keyCode !== 27 && event.keyCode !== 38 && event.keyCode !== 40 ) return;

		let suggestListDom = null;
		let focusedIndex = null;
		let type = null;

    suggestListDom = this.companyListElRef.nativeElement;
    focusedIndex = this.focusedCorpIndex;
    
    let suggestListItem = null;
    if (suggestListDom) suggestListItem = suggestListDom.querySelectorAll('li');


		switch (event.keyCode) {
			case 13: // enter
        if (_.isEmpty(this.filteredCompanyList) || !this.focusedCorpIndex == null || !this.isCorpListOpen) return;
        let item = this.filteredCompanyList[this.focusedCorpIndex];
        this.corpListSelectHandler(item);
        this.isCorpListOpen = false;
			  break;
			case 27: // escape
					this.isCorpListOpen = false;
          
          if (this.selectedCorp) this.companyControl.setValue(this.selectedCorp.corpNm);
          
			  break;
			case 38: // up
        focusedIndex--;
        if (focusedIndex < 0) focusedIndex = 0;
        suggestListItem[focusedIndex].scrollIntoViewIfNeeded(true);
			  break;
			case 40: // down
				focusedIndex++;
        if (focusedIndex > suggestListItem.length - 1) focusedIndex = suggestListItem.length - 1;
        suggestListItem[focusedIndex].scrollIntoViewIfNeeded(false);
        break;
			default: return;
    }	
    if (focusedIndex != this.focusedCorpIndex) this.focusedCorpIndex = focusedIndex;
    event.preventDefault();
  }

  handleCorpBlur($event) {
    if (this.isCorpListOpen) this.isCorpListOpen = false;

    if (this.selectedCorp && $event.target.value) {
      this.companyControl.setValue(this.selectedCorp.corpNm);
    } else {
      this.companyControl.setValue(null);
    }
  }

  corpListSelectHandler(corp) {
    this.isCorpListOpen = false;
    this.selectedCorp = corp;
    
    if(this.selectedCorp != null) {
      this.companyControl.setValue(this.selectedCorp.corpNm);
      this.onCorpSelect.emit(this.selectedCorp);
    }  
    
  }

  

}


// WEBPACK FOOTER //
// ./src/app/containers/promotion/contract/company-selector.ts